<div
  *ngIf="isResourceModalOpen"
  class="modal d-block"
  id="resourceModal"
  tabindex="-1"
  aria-labelledby="resourceModalLabel"
  aria-hidden="true"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
>
  <!-- modal-dialog-centered -->
  <div
    class="modal-dialog modal-md modal-dialog-scrollable resource-modal-dialog"
    style="overflow-y: auto"
  >
    <div class="modal-content resource-modal-content">
      <form [formGroup]="dynamicForm" (ngSubmit)="onSubmit()">
        <!-- Header -->
        <div class="modal-header bg-headers text-white header-height">
          <h5 class="modal-title" id="resourceModalLabel">
            {{ selectedResource?.title || selectedResource?.typeOfForm }}
          </h5>
          <button
            type="button"
            class="btn-close btn-bckclr"
            data-bs-dismiss="modal"
            (click)="closeResourceModal()"
            aria-label="Close"
          ></button>
        </div>

        <!-- Body -->
        <div class="modal-body">
          <!-- Title Description -->
          <p
            *ngIf="selectedResource?.titleDescription"
            class="fw-bold fs12"
            [innerHTML]="selectedResource?.titleDescription"
          ></p>
        <!-- Booking For (UI only – controls coverageType) -->
<div class="dropdown mb-4 coverage-dropdown" *ngIf="!hideCoverageDropdown && !isExapForm()">
  <button
    #coverageDropdownBtn
    class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center"
    type="button"
    data-bs-toggle="dropdown"
    data-bs-display="static"
  >
    <div>
      <strong>Booking For:</strong>
      <ng-container *ngIf="uiCoverageLabels.length; else selectText">
        {{ uiCoverageLabels.join(', ') }}
      </ng-container>
      <ng-template #selectText> Select </ng-template>
    </div>
    <i class="fa fa-chevron-down"></i>
  </button>

  <ul class="dropdown-menu coverage-menu">
    <!-- SELF -->
   <li
  class="coverage-option"
  *ngIf="!isCoverageOrdered('self')"
>
  <label class="coverage-row">
    <input
      type="checkbox"
      (change)="onCoverageUiChange('self', $event, coverageDropdownBtn)"
      style="margin-right:8px;"
    />
    <span>Self</span>
  </label>
</li>


    <!-- SPOUSE -->
<li
  class="coverage-option"
  *ngIf="hasSpouseInfo() && !isCoverageOrdered('spouse')"
>
  <label class="coverage-row">
    <input
      type="checkbox"
      (change)="onCoverageUiChange('spouse', $event, coverageDropdownBtn)"
      style="margin-right:8px;"
    />
    <span>Spouse</span>
  </label>
</li>

    <!-- BOTH -->
<li
  class="coverage-option"
  *ngIf="hasSpouseInfo() && !isCoverageOrdered('both')"
>
  <label class="coverage-row">
    <input
      type="checkbox"
      (change)="onCoverageUiChange('both', $event, coverageDropdownBtn)"
      style="margin-right:8px;"

    />
    <span>Both</span>
  </label>
</li>

  </ul>
</div>


          <div
            *ngIf="selectedResource?.clinicNote"
            class="text-muted small mt-2 fs12"
          >
            <em>{{ selectedResource.clinicNote }}</em>
          </div>

          <!-- 1. Option groups -->

          <!--  EXECUTIVE HEALTH ASSESSMENT UI -->
          <ng-container *ngIf="isExecutiveHealthForm()">
            <div *ngFor="let field of selectedResource?.fields">
              <div
                *ngIf="field.type === 'option-group'"
                class="executive-assessment-ui"
              >
                <h5 class="form-label mb-3 fs12 mt-2">
                  {{
                    field.label || "Please select a clinic for the assessment"
                  }}
                  <span *ngIf="field.required" class="text-danger">*</span>
                </h5>
                <div class="row">

                  <div class="px-4">

                <table class="fs12 w-100 clinic-table">
  <thead>
  <tr>
    <th style="width: 80px;"></th>
    <th>Clinic</th>
    <th>Location</th>
  </tr>
</thead>
  <tbody>
    <ng-container *ngFor="let province of groupedClinicsArray">
        <tr *ngFor="let option of province.value; let i = index"
       [class.province-divider]="i === 0">
        <!-- Province label only on first row -->
        <td *ngIf="i === 0"
            [attr.rowspan]="province.value.length"
            class="province-label"
            (click)="$event.stopPropagation()">
          {{ province.key }}
        </td>

        <!-- Clinic Name -->
           <td>
  <div class="d-flex align-items-center">
    <input
      type="radio"
      class="form-check-input me-2 flex-shrink-0"
      [formControlName]="field.name"
      [value]="option.value"
      [id]="field.name + '_' + option.value"
      (change)="onClinicOptionSelected(option)"
    />
    <label [for]="field.name + '_' + option.value" 
           style="cursor:pointer; margin-bottom:0;">
      {{ displayClinicName(option.value) }}
      <ng-container *ngIf="option.subtext">
        <br/><small class="text-muted">{{ option.subtext }}</small>
      </ng-container>
    </label>
  </div>
</td>
        <!-- Location -->
        <td>
  <div class="d-flex align-items-center">
    <span style="min-width: 100px;">{{ getCityOnly(option.value) }}</span>
   <i *ngIf="hasTooltip(option)"
       class="bi bi-geo-alt-fill ms-1 text-primary"
       [title]="option.tooltip"
       (click)="redirectToMap(option.tooltip); $event.stopPropagation()">
    </i>
  </div>
</td>

      </tr>
    </ng-container>
  </tbody>
</table>
</div>


                  <div
                    class="text-danger small mt-1"
                    *ngIf="
                      dynamicForm.get(field.name)?.invalid &&
                      dynamicForm.get(field.name)?.touched
                    "
                  >
                    {{ getErrorMessage(field.name, field.type) }}
                  </div>
                </div>
              </div>
              <div class="col-12 mt-3" *ngIf="field.type === 'note'">
                <div
                  class="alert alert-info fs12"
                  [innerHTML]="field.content || field.note"
                ></div>
              </div>
            </div>
          </ng-container>

          <!--  NORMAL OPTION GROUP UI (EXAP OR OTHERS) -->
          <ng-container *ngIf="!isExecutiveHealthForm()">
            <div *ngFor="let field of selectedResource?.fields">
              <div *ngIf="field.type === 'option-group'">
                <label class="form-label fs12">{{ field.mainlabel }}</label>
                <div class="d-flex flex-column">
                  <div
                    class="form-check mb-2"
                    *ngFor="let option of field.options"
                  >
                    <input
                      class="form-check-input"
                      type="radio"
                      [formControlName]="field.name"
                      [readonly]="isReadOnlyField(field.name)"
                      [value]="option.value || option"
                      [id]="field.name + '_' + (option.value || option)"
                    />
                    <label
                      class="form-check-label"
                      [for]="field.name + '_' + (option.value || option)"
                    >
                      {{ option.label || option.value || option }}
                        <span *ngIf="option.deductible" class="text-muted ms-2" style="font-size: 11px;">
                         — Deductible: ${{ option.deductible | number }}
                        </span>
                    </label>
                  </div>
                </div>
                <div
                  class="text-danger small mt-1"
                  *ngIf="
                    dynamicForm.get(field.name)?.invalid &&
                    dynamicForm.get(field.name)?.touched
                  "
                >
                  {{ getErrorMessage(field.name, field.type) }}
                </div>
              </div>
            </div>
          </ng-container>
          <!--Normal Input Feilds-->
          <div *ngIf="dynamicForm.get('coverageType')?.value">
            <div class="row">
              <ng-container
                *ngFor="let field of selectedResource?.fields; let i = index"
              >
                <div
                  class="col-12 mb-2"
                  *ngIf="
                    dynamicForm.get('coverageType')?.value?.includes('self') &&
                    isFirstFieldOf('self', i)
                  "
                >
                  <h5 class="fw-bold section-heading">Member Information</h5>
                </div>

                <!-- Spouse Heading -->
                <div
                  class="col-12 mb-2"
                  *ngIf="
                    dynamicForm
                      .get('coverageType')
                      ?.value?.includes('spouse') && isFirstFieldOf('spouse', i)
                  "
                >
                  <h5 class="fw-bold section-heading">Spouse Information</h5>
                </div>

                <!--  Normal Fields -->
<div
  class="col-md-6"
  [style.order]="
    field.name === 'childFirstName' ? 1 :
    field.name === 'childLastName' ? 2 :
    field.name === 'childDob' ? 3 :
    field.name === 'childGender' ? 4 : 0
  "
  *ngIf="
    field.type !== 'signature' &&
    field.name !== 'signature' &&
    field.name !== 'spouseSignature' &&
    field.name !== 'consent' &&
    field.name !== 'spouseConsent' &&
    field.type !== 'select' &&
    field.type !== 'option-group' &&
    field.type !== 'checkbox-group' &&
    field.type !== 'note' &&
    field.type !== 'group' &&
    shouldShowField(field)
  "
>
                  <label
                    *ngIf="field.sublabel && field.sublabel.trim() !== ''"
                    class="form-label"
                    id="modal-labels"
                  >
                    {{ field.sublabel }}
                    <span *ngIf="field.required" class="text-danger">*</span>
                  </label>

                  <ng-container [ngSwitch]="field.type">
                    <input
                      *ngSwitchCase="'text'"
                      type="text"
                      class="form-control"
                      [formControlName]="field.name"
                      [readonly]="dynamicForm.get(field.name)?.disabled"
                    />
                    <input
                      *ngSwitchCase="'email'"
                      type="email"
                      class="form-control"
                      [formControlName]="field.name"
                      [readonly]="dynamicForm.get(field.name)?.disabled"
                    />
                    <input
                      *ngSwitchCase="'date'"
                      type="text"
                      class="form-control"
                      [formControlName]="field.name"
                      [readonly]="dynamicForm.get(field.name)?.disabled"
                    />
                    <input
                      *ngSwitchCase="'number'"
                      type="text"
                      class="form-control"
                      [formControlName]="field.name"
                      [readonly]="dynamicForm.get(field.name)?.disabled"
                    />
                    <textarea
                      *ngSwitchCase="'textarea'"
                      rows="4"
                      class="form-control txt-area"
                      [formControlName]="field.name"
                      [readonly]="dynamicForm.get(field.name)?.disabled"
                    ></textarea>
                  </ng-container>

                  <!-- Validation -->
                  <div
                    class="invalid-feedback"
                    *ngIf="
                      dynamicForm.get(field.name)?.touched &&
                      dynamicForm.get(field.name)?.invalid
                    "
                  >
                    <div
                      *ngIf="dynamicForm.get(field.name)?.errors?.['required']"
                    >
                      {{ field.sublabel || field.name }} is required.
                    </div>
                    <div *ngIf="dynamicForm.get(field.name)?.errors?.['email']">
                      Please enter a valid email.
                    </div>
                  </div>
                </div>

                <!--  Group Fields -->
              
              </ng-container>
            </div>
          </div>
          <!-- MAILING ADDRESS (Self & Spouse) -->
<ng-container *ngIf="shouldShowMailingAddress()">
  <div
    class="col-12 mt-3"
    *ngFor="let field of selectedResource?.fields"
  >
    <ng-container *ngIf="isMailingAddress(field)">
      <h5 class="fw-bold section-heading">Mailing Address</h5>

      <div [formGroupName]="field.name" class="row fs12">
        <div class="col-md-6" *ngFor="let subField of field.fields">
          <label class="form-label" id="modal-labels">
            {{ subField.sublabel }}
            <span *ngIf="subField.required" class="text-danger">*</span>
          </label>

          <input
            [type]="subField.type"
            class="form-control"
            [formControlName]="subField.name"
          />
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>


<!--  Consent Section (keeps your logic same) -->
<ng-container *ngFor="let field of selectedResource?.fields">
  <div
    class="mb-3"
    *ngIf="
      field.type === 'checkbox' &&
      ((field.name === 'consent' &&
        (dynamicForm.get('coverageType')?.value?.includes('self') ||
          isChildCoverageSelected())) ||
        (field.name === 'spouseConsent' &&
          dynamicForm.get('coverageType')?.value?.includes('spouse')))
    "
  >
    <h5 class="mt-4" style="font-size: 14px">
      {{
        isChildCoverageSelected() ? "Parent/Guardian Consent" :
        (field.name === "consent" ? "Member Consent" : "Spouse Consent")
      }}
      <span *ngIf="field.required" class="text-danger">*</span>
    </h5>

              <div class="form-check checkbx">
                <input
                  type="checkbox"
                  class="form-check-input"
                  [id]="field.name"
                  [formControlName]="field.name"
                  [required]="field.required"
                />
                <label
                  class="form-check-label checkbx-label"
                  id="modal-labels"
                  [for]="field.name"
                  (click)="onConsentLabelClick($event)"
                >
                  <ng-container
                    *ngIf="
                      field.sublabel?.includes('Privacy Policy');
                      else normalConsent
                    "
                  >
                    {{ field.sublabel.split("Privacy Policy")[0] }}
                    <a
                      href="#"
                      (click)="openPolicy('privacy')"
                      data-bs-toggle="modal"
                    >
                      Privacy Policy
                    </a>
                    and
                    <a
                      href="#"
                      (click)="openPolicy('terms')"
                      data-bs-toggle="modal"
                    >
                      Terms of Use
                    </a>
                  </ng-container>
                  <ng-template #normalConsent>
                    <span [innerHTML]="field.sublabel"></span>
                  </ng-template>
                </label>
              </div>
              <div
                class="text-danger small"
                *ngIf="
                  dynamicForm.get(field.name)?.invalid &&
                  dynamicForm.get(field.name)?.touched
                "
              >
                {{ getErrorMessage(field.name) }}
              </div>
            </div>
          </ng-container>

<!--  SIGNATURE SECTION -->
<ng-container
  *ngFor="let field of selectedResource?.fields; let i = index"
>
<div
  *ngIf="
    field.type === 'signature' &&
    (
      (field.name === 'signature' &&
        (dynamicForm.get('coverageType')?.value === 'self' ||
         dynamicForm.get('coverageType')?.value?.includes?.('self') ||
         isChildCoverageSelected())) ||
      (field.name === 'spouseSignature' &&
        (dynamicForm.get('coverageType')?.value === 'spouse' ||
         dynamicForm.get('coverageType')?.value?.includes?.('spouse')))
    )
  "
  class="signature-container-wrapper mb-4"
>
    <!--  Heading Above Each Canvas -->
    <h5 class="signature-heading" style="font-size: 14px">
      {{
        isChildCoverageSelected() ? "Child Signature" :
        (field.name === "spouseSignature"
          ? "Spouse Signature"
          : "Member Signature")
      }}
      <span *ngIf="field.required" class="text-danger">*</span>
    </h5>
              <div class="signature-container position-relative">
                <canvas
                  #sigPad
                  [id]="field.name"
                  style="cursor: default"
                  width="400"
                  height="150"
                  class="signature-canvas"
                  (mousedown)="onMouseDown($event, field.name)"
                  (mousemove)="onMouseMove($event, field.name)"
                  (mouseup)="onMouseUp(field.name)"
                  (mouseleave)="onMouseUp(field.name)"
                  (touchstart)="onMouseDown($event, field.name)"
                  (touchmove)="onMouseMove($event, field.name)"
                  (touchend)="onMouseUp(field.name)"
                ></canvas>
                <div
                  class="text-danger small"
                  *ngIf="
                    dynamicForm.get(field.name)?.invalid &&
                    dynamicForm.get(field.name)?.touched
                  "
                >
                                    Signature is required
                </div>

                <button
                  type="button"
                  class="btn btn-sm btn-light clear-signature-btn"
                  (click)="clearSignature1(field.name)"
                  style="color: red"
                >
                  Clear
                </button>
              </div>
            </div>
          </ng-container>

          <!--  Disclaimer (remains last) -->
          <ng-container *ngFor="let field of selectedResource?.fields">
            <div
              class="mb-2 small text-muted font-fs"
              *ngIf="field.type === 'disclaimer' && field.name === 'disclaimer'"
            >
              <span [innerHTML]="field.text"></span>
            </div>
          </ng-container>
        </div>

        <!-- Footer -->
        <div class="modal-footer py-2">
          <button
            type="button"
            class="btn btn-sm btn-light cancel"
            data-bs-dismiss="modal"
            id="closeResourceModal"
            (click)="closeResourceModal()"
          >
            Cancel
          </button>
        <button type="submit" class="btn btn-sm btn-light save">
  Order
</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Policy Modal -->
<div
  class="modal modal-xl fade"
  id="policyModal"
  tabindex="-1"
  aria-labelledby="policyModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content policyc-mod-wid">
      <div class="modal-header bg-headers text-white">
        <h5 class="modal-title" id="policyModalLabel">{{ modalTitle }}</h5>
        <button
          type="button"
          class="btn-close btn-bckclr"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div [innerHTML]="modalContent"></div>
      </div>
    </div>
  </div>
</div>

<!-- Location Modal -->
<div
  class="modal fade"
  id="mapModal"
  tabindex="-1"
  aria-labelledby="mapModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content" style="height: 350px">
      <div class="modal-header bg-headers text-white">
        <h5 class="modal-title" id="mapModalLabel">Location Map</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          style="background-color: white"
        ></button>
      </div>
      <div class="modal-body p-0">
        <iframe
          *ngIf="selectedMapUrl"
          [src]="selectedMapUrl"
          width="100%"
          height="450"
          style="border: 0"
          allowfullscreen
          loading="lazy"
        ></iframe>
      </div>
    </div>
  </div>
</div>

<div class="modal" *ngIf="isExternalRedirect">
  <div class="modal-content">
    <h4>Leaving GroupBenefitz</h4>
    <p>You will be redirected to an external site to continue your assessment.</p>

    <button class="btn btn-secondary" (click)="isExternalRedirect = false">
      Cancel
    </button>

    <button class="btn btn-primary" (click)="confirmRedirect()">
      Continue
    </button>
  </div>
</div>


